const SENTINELS = new Set(["", "LOCAL", "NETLIFY"]);

/** Vite inlines this dot access. Bracket access stays as `process.env` at runtime. */
export const loadedUiSha = (): string => process.env.REACT_APP_GIT_SHA || "";

// `REACT_APP_APP_ENV=dev` is app.dev and app-us.dev. Prod stays on the chunk-miss reload.
export const shouldCheckForUpdate = (
  sha: string,
  appEnv: string = process.env.REACT_APP_APP_ENV || ""
): boolean => appEnv === "dev" && !SENTINELS.has(sha);

export const shaFromHtml = (html: string): string | null => {
  const content = new DOMParser()
    .parseFromString(html, "text/html")
    .querySelector('meta[name="ui-sha"]')
    ?.getAttribute("content");
  return content || null;
};

export const isDifferentSha = (
  loaded: string,
  remote: string | null
): boolean => remote !== null && remote !== loaded;

export const indexHtmlUrl = (
  publicUrl: string = process.env.PUBLIC_URL ?? "",
  origin: string = window.location.origin
): string => {
  const base = publicUrl.endsWith("/") ? publicUrl : `${publicUrl}/`;
  return new URL("index.html", new URL(base, origin)).href;
};
